import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';

export default function WhatIfScenarioChangesDialog(props) {
	const { scenario, rows, onClose } = props;
	const mainTheme = useSelector(selectMainTheme);

	return (
		<ThemeProvider theme={mainTheme}>
			<Dialog open fullWidth maxWidth="sm">
				<DialogTitle disableTypography className="border-b flex flex-col px-0">
					<div className="flex items-center justify-between gap-32 px-32">
						<div className="min-w-0 whitespace-nowrap overflow-hidden overflow-ellipsis">
							{scenario?.name ? `${scenario.name} changes` : 'Scenario changes'}
						</div>
					</div>
				</DialogTitle>

				<DialogContent className="w-full flex flex-col p-20 overflow-hidden" style={{ maxHeight: 520 }}>
					<TableContainer className="flex-1 overflow-auto -mr-20 pr-20">
						<Table className="w-full" aria-label="scenario changes">
							<TableHead>
								<TableRow>
									<TableCell>Attribute</TableCell>
									<TableCell>Current value</TableCell>
									<TableCell>Scenario value</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.length > 0 ? rows.map(row => (
									<TableRow key={row.key}>
										<TableCell component="th" scope="row">
											{row.name}
										</TableCell>
										<TableCell className="font-mono break-all">{row.currentValueText}</TableCell>
										<TableCell className="font-mono break-all">{row.scenarioValueText}</TableCell>
									</TableRow>
								)) : (
									<TableRow>
										<TableCell component="th" scope="row" colSpan={3} align="center">
											No changed values
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>

				<DialogActions className="justify-between border-t p-20">
					<Button onClick={onClose}>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	);
}
